function setMuiComponentAndMaybeFocus(c) {
  if (c === this.muiComponent) return;

  this.muiComponent = c;

  if (c && typeof c.focus === 'function') {
    this.focus = () => c.focus();
  } else if (Object.prototype.hasOwnProperty.call(this, 'focus')) {
    delete this.focus;
  }
}

export default setMuiComponentAndMaybeFocus;
